<template>
  <div class="container">
    <v-skeleton-loader :loading="loading" type="card, article@3">
      <h2 class="mb-3 d-none d-md-flex">Detail Tiket</h2>

      <div v-if="data.is_paid == 0">
        <v-alert text color="primary" icon="info">
          Segera lakukan pembayaran Anda
        </v-alert>
      </div>

      <div v-if="data.is_paid == 0">
        <v-card outlined class="mb-3">
          <v-card-title>Belum dibayar</v-card-title>
          <v-card-subtitle>
            <div>
              Lakukan pembayaran sesuai dengan nominal tagihan berikut dan klik
              konfirmasi jika telah melakukan pembayaran
            </div>
          </v-card-subtitle>

          <v-list
            rounded
            two-line
            subheader
            color="grey lighten-4"
            v-if="data.is_manual_payment == 1"
          >
            <v-list-item>
              <v-list-item-content>
                <v-list-item-subtitle>Total</v-list-item-subtitle>
                <v-list-item-title
                  v-text="data.price_amout"
                ></v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                <v-btn icon @click="clipboard(data.total)">
                  <v-icon color="blue lighten-1">content_copy</v-icon>
                </v-btn>
              </v-list-item-action>
            </v-list-item>
            <v-list-item>
              <v-list-item-avatar>
                <v-img :src="data.payment.logo" />
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title
                  v-text="data.payment.bank_name"
                ></v-list-item-title>
                <v-list-item-subtitle
                  v-text="
                    data.payment.bank_account +
                    ' a.n ' +
                    data.payment_method.holder_name
                  "
                ></v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action>
                <v-btn icon @click="clipboard(data.payment.bank_account)">
                  <v-icon color="blue lighten-1">content_copy</v-icon>
                </v-btn>
              </v-list-item-action>
            </v-list-item>
          </v-list>

          <v-list rounded two-line subheader color="grey lighten-4" v-else>
            <v-list-item value="0">
              <v-list-item-avatar>
                <v-icon class="blue lighten-1" dark> credit_card </v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title>Payment Gateway</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
          <v-card-text v-if="data.date_payment">
            Pembayaran kamu sedang dalam pengecekan oleh admin 1x24 jam. Jika
            tidak terjadi perubahan klik Konfirmasi kembali
          </v-card-text>
          <v-card-actions v-if="data.is_manual_payment == 1">
            <v-btn
              block
              outlined
              color="primary"
              @click="confirmPaymentUpload(data.code)"
              :loading="btnConfirmLoading"
              >Konfirmasi</v-btn
            >
          </v-card-actions>
          <v-card-actions v-else>
            <v-btn block outlined color="primary" @click="payMidtrans"
              >Bayar Sekarang</v-btn
            >
          </v-card-actions>
        </v-card>
      </div>

      <div v-else>
        <v-card outlined class="mb-3">
          <div class="d-flex justify-center align-content-center align-center">
            <VueBarcode
              :value="data.code"
              :options="{ width: 1, height: 50, fontSize: 12 }"
            />
          </div>
        </v-card>
      </div>

      <v-card outlined>
        <div class="d-flex flex-no-wrap justify-space-between">
          <div>
            <v-card-title
              class="title text-wrap"
              v-text="data.event_title"
            ></v-card-title>
            <v-card-subtitle>
              <div>{{ data.event_date }}, {{ data.event_time }}</div>
              <div>{{ data.event_place }}</div>
            </v-card-subtitle>
          </div>
          <v-avatar class="ma-3" size="80" tile>
            <v-img :src="data.cover"></v-img>
          </v-avatar>
        </div>
        <v-card-actions>
          Deskripsi

          <v-spacer></v-spacer>

          <v-btn icon @click="show = !show">
            <v-icon>{{ show ? 'expand_less' : 'expand_more' }}</v-icon>
          </v-btn>
        </v-card-actions>

        <v-expand-transition>
          <div v-show="show">
            <v-divider></v-divider>

            <v-card-text v-html="data.event_description"> </v-card-text>
          </div>
        </v-expand-transition>
      </v-card>

      <v-card outlined class="mt-3">
        <v-card-text>
          <v-row>
            <v-col cols="6">
              <div>Ticket {{ data.ticket_name }}</div>
              <div class="font-weight-bold orange--text">
                {{ data.price_amout }}
              </div>
            </v-col>
            <v-col cols="6">
              <div>ID Transaksi</div>
              <div class="font-weight-bold orange--text">
                {{ data.code }}
              </div>
            </v-col>
            <v-col cols="6">
              <div>Kategori</div>
              <div class="font-weight-bold orange--text">
                {{ data.event_category }}
              </div>
            </v-col>
            <v-col cols="6">
              <div>Sertifikat</div>
              <div class="font-weight-bold orange--text">
                {{ data.is_certificate == 1 ? 'Yes' : 'No' }}
              </div>
            </v-col>
            <v-col cols="6">
              <div>Snack</div>
              <div class="font-weight-bold orange--text">
                {{ data.is_snack == 1 ? 'Yes' : 'No' }}
              </div>
            </v-col>
            <v-col cols="6">
              <div>Pembayaran</div>
              <div class="font-weight-bold orange--text">
                <span v-if="data.is_paid == 1">Lunas</span>
                <span v-else-if="data.is_paid == 3">Waktu Habis</span>
                <span v-else>Menunggu pembayaran</span>
                {{
                  data.midtrans_payment_method
                    ? '(' + data.midtrans_payment_method + ')'
                    : ''
                }}
              </div>
            </v-col>
            <v-col cols="6">
              <div>Kehadiran</div>
              <div class="font-weight-bold orange--text">
                Check In: {{ data.check_in == null ? '-' : data.check_in }}
              </div>
            </v-col>
            <v-col cols="6">
              <div>Tempat</div>
              <div class="font-weight-bold orange--text">
                {{ place }}
              </div>
            </v-col>

            <v-col cols="12">
              <div v-if="data.post_event">
                <v-btn
                  v-if="data.is_certificate == 1 && data.check_in != null"
                  class="success"
                  block
                  @click="viewCertificate"
                  >Lihat Sertifikat</v-btn
                >
              </div>
              <div v-else>
                <div v-if="is_online == 1">
                  <p>Link akan aktif saat event dimulai</p>
                  <div>
                    <v-btn
                      class="primary mb-3"
                      block
                      :disabled="data.disable_link"
                      :loading="attendLoading"
                      :to="{ name: 'MyTicketScan'}"
                      >Scan</v-btn
                    >
                    <v-btn
                      v-if="data.check_in == null"
                      class="primary"
                      block
                      :disabled="data.disable_link"
                      :loading="attendLoading"
                      @click="attend"
                      >Check In</v-btn
                    >
                    <v-btn
                      v-else
                      class="primary"
                      block
                      :disabled="data.disable_link"
                      :href="data.online_url"
                      target="_blank"
                      >Link Event Online</v-btn
                    >
                  </div>
                </div>
                <div class="mt-3" v-if="data.is_paid == 1">
                  <v-btn class="secondary" block @click="addToCalendar"
                    >Add to my Calendar</v-btn
                  >
                </div>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-skeleton-loader>
    <v-snackbar v-model="snackbar" :timeout="2000">
      {{ snackbarText }}

      <template v-slot:action="{ attrs }">
        <v-btn color="blue" text v-bind="attrs" @click="snackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import Axios from 'axios';
import VueBarcode from '@chenfengyuan/vue-barcode';
import midtrans from '@/plugins/midtrans';

export default {
  name: 'MyTicketDetail',
  components: { VueBarcode },
  data() {
    return {
      show: false,
      showInfo: false,
      transaction_id: this.$route.params.transaction_id,
      loading: true,
      data: [],
      place: null,
      is_online: 0,
      responseAttendance: [],
      error: false,
      errorMessage: null,
      token: 'Bearer ' + localStorage.getItem('token'),
      user: JSON.parse(localStorage.getItem('user')),
      attendLoading: false,
      midtrans: null,
      snackbar: false,
      snackbarText: 'Hello',
      btnConfirmLoading: false,
    };
  },
  created() {
    this.initMidtransScript();
  },
  mounted() {
    this.loadTicketDetail();
  },
  methods: {
    loadTicketDetail() {
      Axios.get(
        process.env.VUE_APP_API + 'my-ticket/detail/' + this.transaction_id,
        {
          headers: {
            Authorization: this.token,
          },
        },
      )
        .then((response) => {
          this.data = response.data.data;
          this.place = this.data.event.place;
          this.is_online = this.data.event.is_online;
        })
        .catch((error) => {
          if (error.response.status === 404) {
            this.$router.push({ name: 'NotFound' });
          }
          this.error = true;
          this.errorMessage = error;
        })
        .finally(() => (this.loading = false));
    },
    initMidtransScript() {
      midtrans.initScript().then(() => {
        setTimeout(() => {
          midtrans.globalWindow();
          // this.$vs.loading.close();
        }, 1500);
      });
      // console.log(midtrans.initScript());
    },
    async payMidtrans() {
      // eslint-disable-next-line no-useless-catch
      // console.log(this.data.snap_token);
      // eslint-disable-next-line no-useless-catch
      try {
        window.$MIDTRANS.pay(this.data.snap_token, {});
      } catch (e) {
        throw e;
      }
    },
    attend() {
      this.attendLoading = true;
      Axios.get(
        process.env.VUE_APP_API + 'my-ticket/attend/' + this.transaction_id,
        {
          headers: {
            Authorization: this.token,
          },
        },
      )
        .then((response) => {
          this.responseAttendance = response.data.data;
          this.loadTicketDetail();

          // window.open(this.data.online_url, '_blank');
        })
        .catch((error) => {
          this.error = true;
          this.errorMessage = error;
        })
        .finally(() => (this.attendLoading = false));
    },
    viewCertificate() {
      window.open(
        process.env.VUE_APP_DASHBOARD + 'certificate/' + this.data.code,
        '_blank',
      );
      // alert(process.env.VUE_APP_DASHBOARD + 'certificate/' + this.data.code);
    },
    addToCalendar() {
      window.open(this.data.link_google_calendar, '_blank');
    },
    clipboard(str) {
      const el = document.createElement('textarea');
      el.addEventListener('focusin', (e) => e.stopPropagation());
      el.value = str;
      document.body.appendChild(el);
      el.select();
      document.execCommand('copy');
      document.body.removeChild(el);

      this.snackbarText = 'Berhasil disalin ke papan klip';
      this.snackbar = true;
    },
    confirmPayment() {
      /* This is action to hit back end for confirmation payment with update date_payment*/
      this.btnConfirmLoading = true;
      Axios.post(
        process.env.VUE_APP_API + 'confirm-payment',
        {
          transaction_id: this.transaction_id,
        },
        {
          headers: {
            Authorization: this.token,
          },
        },
      )
        .then((response) => {
          if (response.status == 200) {
            this.loadTicketDetail();
          }
        })
        .catch((error) => {
          console.log(error);
          this.snackbarText = 'Terjadi kesalahan sistem';
          this.snackbar = true;
        })
        .finally(() => {
          this.btnConfirmLoading = false;
          this.snackbarText = 'Konfirmasi pembayaran terkirim';
          this.snackbar = true;
        });
    },
    confirmPaymentUpload(transaction_code) {
      /* This is direct to laravel for upload proof of payment*/
      window.location.href =
        process.env.VUE_APP_DASHBOARD + 'cp/' + transaction_code;
    },
  },
};
</script>

<style scoped></style>
